import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import Headline3 from '../Typography/Heading/Headline3';
import Body1 from '../Typography/Body/Body1';

const Header = styled(Headline3)`
  text-align: center;
  display: none;
  padding: 20px 36px;

  @media (min-width: 480px) {
    display: block;
  }
`;

const SubHeader = styled(Body1)`
  text-align: center;
`;

const LookbookHeader = ({ title, subtitle }) => (
  <>
    <Header tag="h1">{ title }</Header>
    <SubHeader>{ subtitle }</SubHeader>
  </>
);

LookbookHeader.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
};

export default LookbookHeader;
